import { createBaseThemeVariation } from './base';
export const NFamilySchoolTheme = createBaseThemeVariation({
    name: 'nfamilyschool',
    brandColor: 'hsla(221, 69%, 14%, 1)',
    primaryColors: {
        p50: 'hsla(221, 69%, 98%, 1)',
        p75: 'hsla(221, 69%, 97%, 1)',
        p100: 'hsla(221, 69%, 96%, 1)',
        p200: 'hsla(221, 69%, 90%, 1)',
        p300: 'hsla(221, 69%, 70%, 1)',
        p400: 'hsla(221, 69%, 14%, 1)',
        p500: 'hsla(221, 69%, 8%, 1)',
    },
});
